import { useApiQuery } from '../useApiQuery';
import { reminderKeys } from '@/lib/queryKeys';
import { remindersV2 } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { ReminderAuditEntry } from '@/types/reminder';

interface AuditLogResponse {
  data: ReminderAuditEntry[];
}

/**
 * Audit trail entries for a reminder (spec §13.5 / §13.6).
 *
 * Returned newest-first by the backend service.
 */
export function useReminderAuditLog(
  id: string | undefined | null,
  options: { enabled?: boolean } = {},
) {
  const { enabled = true } = options;

  return useApiQuery<ReminderAuditEntry[]>({
    queryKey: reminderKeys.auditLog(id ?? '__none__'),
    queryFn: async () => {
      const res = await apiGet<AuditLogResponse>(operationsClient, remindersV2.auditLog(id!));
      return res.data;
    },
    enabled: Boolean(id) && enabled,
    showErrorToast: false,
  });
}
